import vuetify from "vuetify/es5/locale/zh-Hant";
import validations from "@/lang/zh_hant/validations";
import phoneCountryCodes from "@/lang/zh_hant/phone-country-codes";
import teachingSubjects from "@/lang/zh_hant/teaching-subjects";
import teacherMajorDuties from "@/lang/zh_hant/teacher-major-duties";
import teacherInterestAreaList from "@/lang/zh_hant/teacher-interest-area";
import parentInterestAreaList from "@/lang/zh_hant/parent-interest-area";
import accountCategoryCodes from "@/lang/zh_hant/account-category-codes";
import changePassword from "@/lang/zh_hant/change-password";
import forgetPassword from "@/lang/zh_hant/forget-password";
import resetPassword from "@/lang/zh_hant/reset-password";
import userActivation from "@/lang/zh_hant/user-activation";
import regenQrcode from "@/lang/zh_hant/regen-qrcode";
import family from "@/lang/zh_hant/family";
import accountAssociation from "@/lang/zh_hant/account-association";
import loginInfo from "@/lang/zh_hant/login-info";
import otp from "@/lang/zh_hant/otp";
import buyerAccountActivation from "@/lang/zh_hant/buyer-account-activation";

export default {
  $vuetify: vuetify,
  title: "香港教育城",
  forbidden: "你沒有權限更新此頁。 ",
  edcityHome: "教城主頁",
  openMenu: "展開選單",
  closeMenu: "收起選單",
  accountSetting: "帳戶設定",
  logout: "登出",
  submit: "提交",
  press: "按此",
  recaptchaLang: "zh-HK",
  fatalError: {
    unauthorized: "登入違時，請重新登入後再試一次。",
    unknown:
      "發生問題，請稍後再重新登入。如果問題仍然持續，請電郵至 support@edcity.hk。",
  },
  success: {
    basicProfileUpdated: "您的個人檔案已更新。",
    basicProfileUpdatedIncludeLoginEmail:
      "您的個人檔案已更新。確認電郵已經發送至{email}，請於{date}或之前確認變更。您的新登入電郵將會在認證程序完成後生效。",
    basicProfileUpdatedIncludeContactEmail:
      "您的個人檔案已更新。確認電郵已經發送至{email}，請於{date}或之前確認變更。您的新聯絡電郵將會在認證程序完成後生效。",
    teacherProfileUpdated: "您的教師資料已更新。",
    teacherProfileUpdatedIncludeTeacherEmail:
      "您的教師資料已更新。確認電郵已經發送至{email}，請於{date}或之前以完成認證。",
    parentProfileUpdated: "您的家長資料已更新。",
    organizationAccountListUpdated: "帳戶已更新。",
    organizationAccountListUploaded: "帳戶已上載。",
    passwordIsChanged: "您已成功設定新密碼。",
    accountActivated: "成功啟動教育城戶口及更新密碼",
    loginQrcodeRegenerated: "您的登入二維碼已刷新。",
    loginInfoUpdated: "您的登入訊息已更新。",
  },
  validations,
  phoneCountryCodes,
  teachingSubjects,
  teacherMajorDuties,
  teacherInterestAreaList,
  parentInterestAreaList,
  accountCategoryCodes,
  changePassword,
  forgetPassword,
  resetPassword,
  userActivation,
  regenQrcode,
  family,
  accountAssociation,
  loginInfo,
  otp,
  buyerAccountActivation,
  profile: {
    menuList: {
      selfService: "自助服務",
      emailForwarding: "設定電郵轉寄功能",
      favourite: "我的收藏",
      myRecords: "我的記錄",
      subscription: "訂閱",
      edcityHomepage: "前往教城主頁",
      editProfile: "新增／更新個人檔案",
      basicProfile: "個人資料",
      teacherProfile: "教師身分資料",
      parentProfile: "家長身分資料",
      familyProfile: "綁定家庭",
      password: "密碼",
      changePassword: "變更密碼",
      regenQrcode: "變更登入二維碼",
      accountAssociation: "帳戶關聯",
      loginInfo: "登入資訊",
    },
    basic: {
      heading: "更新個人資料",
      loginEmail: "登入電郵",
      loginEmailTooltip:
        "確認電郵將會發送到您輸入的電郵地址，請點按電郵中的連結以確認變更。如您沒有收到確認電郵或需作出其他更改，請重新提出確認要求。",
      accountInfoHeading: "帳戶資料",
      cityId: "登入名稱",
      accountCategory: "帳戶類別",
      personalInfoHeading: "個人信息",
      title: "稱謂",
      titles: {
        mr: "先生",
        mrs: "太太",
        miss: "小姐",
        ms: "女士",
      },
      chiSurname: "中文姓氏",
      chiGivenName: "中文名字",
      engSurname: "英文姓氏",
      engGivenName: "英文名字",
      displayName: "別名",
      displayNameTooltip: "可隨時更改",
      generateDisplayName: "生成別名",
      contactEmail: "聯絡電郵",
      mobileCountryCode: "國家 或 地區",
      mobilePhoneNum: "手提電話號碼",
      subscriptionHeading: "訂閱教城資訊",
      subscription: "請選擇您希望接收的電子報及活動資訊：",
      subscriptions: {
        edPost: "教城電子報",
        teacherInfo: "教師資訊",
        parentInfo: "家長資訊",
        studentInfo: "學生資訊",
        DoNotCall: "我不希望收取任何教城資訊。",
      },
      thirdPartyHeading: "將第三方帳戶與教城帳戶連繫",
      thirdPartyHeadingMember: "將第三方帳戶與教城會員連繫",
      thirdPartyAccount: "您可以使用以下第三方帳戶登入教城網站。",
      connectInstruction: "請點擊以下圖示以連繫 / 取消連繫。",
      loginEmailUnaccepted: "@:registration.loginEmailUnaccepted",
      loginEmailInUse: "已有其他人選用此電郵地址。請使用其他電郵地址。",
      chiSurnameBadword: "切勿使用不雅用語，請輸入其他中文姓氏。",
      chiGivenNameBadword: "切勿使用不雅用語，請輸入其他中文名字。",
      engSurnameBadword: "切勿使用不雅用語，請輸入其他英文姓氏。",
      engGivenNameBadword: "切勿使用不雅用語，請輸入其他英文名字。",
      displayNameBadword: "切勿使用不雅用語，請輸入其他別名。",
      displayNameInUse: "已有其他人選用此別名，請使用其他名稱。",
      loginEmailPending: "此電郵地址已被登記，並正等待啟用。",
      contactEmailRequired: "請輸入您的電郵地址。",
      mobileVerification: {
        no: "未認證",
        yes: "已認證",
        verifyButton: "認證",
        reVerifyButton: "更改號碼",
        sendSMSButton: "發送驗證碼",
        backToSendButton: "返回發送驗證碼",
        backToProfileButton: "返回個人資料",
        codeLabel: "輸入驗證碼",
        heading: "認證手提電話號碼",
        code: "驗證碼",
        info: "",
        verifySuccess: "驗證成功",
        countdown: "驗證碼有效時間：",
        errors: {
          sendFail: "發送失敗，請重試。",
        },
      },
      upgradeStudentMemberPopUp: {
        title: "升級學生會員",
        intro: {
          desc: "為提供全方位個人化服務，您可以綁定您的校本專屬帳戶到個人會員帳戶。個人會員帳戶由您擁有，可以自行管理帳戶及永久檢視於教城完整的用戶資料及活動紀錄而不受升班或轉校影響。",
          tos: "服務條款",
          acceptTos:
            "我已閱讀並同意香港教育城訂立的 {privacy}、 {copyright}、 {disclaimer}和 {tac}。",
          privacyStatement: "私隱政策聲明",
          privateStatementUrl: "https://www.edcity.hk/home/zh-hant/dataprivacy",
          copyright: "版權及知識產權",
          copyrightUrl: "https://www.edcity.hk/notices/tc_chinese.php#s2",
          disclaimer: "免責聲明",
          disclaimerUrl: "https://www.edcity.hk/notices/tc_chinese.php#s3",
          tac: "服務條款",
          tacUrl: "https://www.edcity.hk/notices/tc_chinese.php#s4",
          upgradeButton: "升級",
          skipButton: "跳過",
        },
        inputEmail: {
          stepTitle: "個人電郵",
          title: "輸入您的個人電郵",
          desc: "升級學生會員可讓您更容易管理您的學生帳戶。除學校為您建立的登入名稱或學校電郵外，您可使用個人電郵作登入用途。請輸入您的個人電郵並進行認證。",
          email: "個人電郵",
          sendButton: "發送驗證碼",
        },
        verifyEmail: {
          stepTitle: "認證電郵",
          title: "輸入您的個人電郵驗證碼",
          desc: "請輸入發送到您個人電郵的驗證碼。輸入後,請點擊以下按鈕以驗證電子郵件",
          button: "驗證",
          code: "驗證碼",
          verifySuccess: "驗證成功",
          countdown: "驗證碼有效時間：",
          codeExpired: "驗證碼已逾時，請返回重新發送",
        },
        verifiedEmail: {
          title: "已成功驗證!",
          desc: "您的電子郵件已被驗證。現在您可以繼續執行下一步來訂閱教城資訊。",
          button: "下一步",
        },
        subscribeNews: {
          stepTitle: "訂閱教城資訊",
          desc: "升級學生會員後, 您於學生帳戶所訂閱的教城資訊將轉移到您的個人電郵。請確認或更改您的選項。",
          subscribeButton: "確認",
          cancelButton: "取消",
        },
        linkEmail: {
          stepTitle: "綁定個人電郵",
          createDesc:
            "請輸入新密碼作為此個人電郵的登入資訊。請留意，學校管理員為您建立的登入資料同時存在而不會被改變。",
          updateDesc:
            "您所輸入的個人電郵已經存在, 您確定要綁定至此學生帳戶 ( 登入名稱: {cityId} )嗎? ",
          linkButton: "綁定",
          cancelButton: "取消",
        },
        finish: {
          stepTitle: "完成",
          title: "已成功升級!",
          desc: "恭喜您！您已成功升級學生會員。",
          finishButton: "完成",
        },
      },

      upgradePopupStepTitle: {
        title: "申請升級會員",
        emailVer: "第一步 - 驗證電子郵件地址",
        phoneVer: "第二步 - 驗證手提電話號碼",
        info: "第三步 - 更新用戶個人資料",
        finish: "完成升級",
        next: "下一步",
        upgrade: "升級",
        lastStep: "上一步",
        stepper_email: "登入電郵",
        stepper_sms: "手提電話",
        stepper_info: "個人資料",
        stepper_done: "完成升級",
      },
      upgradePopupWelcome: {
        title: "申請升級會員",
        desc: "驗證您的身分以體驗所有功能。過程需時約 5 分鐘",
        requirement: "您需要以下資料：",
        requirement1: "準備一個電郵地址",
        requirement2: "準備一個可以收發簡訊的電話號碼",
        requirement3: "個人訊息，包括性別、出生年份和地址",
        upgradeButton: "開始升級",
        skipButton: "跳過",
        errorMsg: "出了點問題，請稍後再試",
      },
      emailVerPopup: {
        title: "輸入您的電郵地址",
        desc: "輸入電郵地址後，請點擊以下按鈕以發送驗證碼到閣下的電郵",
        sendButton: "發送驗證碼",
        email: "電郵地址",
        emailInvalid: "無效的電郵地址",
        emailRequired: "請輸入您的電郵地址",
      },
      emailCodeVerPopup: {
        title: "輸入您的電郵驗證碼",
        desc: "請輸入發送到您電郵地址的 6 位數驗證碼。",
        button: "驗證",
      },
      emailVerifiedPopup: {
        title: "已成功驗證!",
        desc: "您的電子郵件已被驗證。現在您可以繼續執行下一步來驗證電話號碼。",
        button: " 下一步",
      },
      mobileVerifiedPopup: {
        title: "已成功驗證!",
        desc: "您的手提電話號碼已被驗證。現在您可以繼續執行下一步來更新您的個人資料。",
        button: " 下一步",
      },
      verPopupFinish: {
        title: "已成功升級!",
        desc: "感謝升級您的帳戶。您現在可以體驗所有功能。",
        button: "完成",
      },
      verPopupInfo: {
        title: "更新用戶個人資料",
        gender: "性別 ",
        genderMale: "男",
        genderFemale: "女",
        yearOfBirth: "出生年份",
        selfClaimTitle: "您的身分",
        selfClaimTeacher: "老師",
        selfClaimStudent: "學生",
        selfClaimParent: "家長",
        selfClaimRequired: "請選擇您的身分",
        genderRequired: "請選擇性別",
        birthRequired: "請選擇出生年份",
        addressLine1: "地址第一行",
        addressLine2: "地址第二行",
        region: "地區",
        district: "區域",
        button: "更新",
        regionHK: "香港",
        regionCN: "中國",
        regionMU: "澳門",
        regionOR: "其他",
        districtHK: {
          yuenLong: "元朗",
          yauTsimMong: "油尖旺",
          wongTaiSin: "黃大仙",
          wanChai: "灣仔",
          tuenMun: "屯門",
          tsuenWan: "荃灣",
          taiPo: "大埔",
          southern: "南區",
          shamShuiPo: "深水埗",
          shaTin: "沙田",
          saiKung: "西貢",
          north: "北區",
          kwunTong: "觀塘",
          kwaiTsing: "葵青",
          kowloonCity: "九龍城",
          islands: "離島",
          eastern: "東區",
          centralAndWestern: "中西區",
        },
      },
      address: {
        heading: "地址",
        region: "地區",
        district: "區域",
        chiAddressLine1: "中文地址第一行",
        chiAddressLine2: "中文地址第二行",
        engAddressLine1: "英文地址第一行",
        engAddressLine2: "英文地址第二行",
      },
      studentAccountInfo: {
        heading: "學校資料",
        info: "（學生資料，不能修改）",
        schoolName: "學校",
        chiFullName: "中文姓名",
        engFullName: "英文姓名",
        class: "班級(班號)",
        schoolEmail: "學校電郵",
        upgradeButton: {
          studentMember: "升級學生會員",
          fullMember: "升級會員",
        },
      },
    },
    teacher: {
      heading: "更新教師身分資料",
      teacherType: "請選擇教師類別：",
      teacherTypes: {
        registered: "註冊教師（需以教育局提供的e-Services帳戶認證）",
        preService: "師訓機構學生",
        prePrimary: "學前教育教師",
        universityTeacher: "大學教職員",
        retired: "退休教師",
        others: "其他類別教師",
        required: "請選擇教師類別",
        invalid: "無效的教師類別",
      },
      teacherTypeHints: {
        registered:
          "認證電郵將會發送至以下的帳戶，您需要登入e-Services系統(https://eservices.edb.gov.hk/)，查閱電郵，以完成認證。",
        preService: "認證電郵將會發送至以下的帳戶，請查閱電郵，以完成認證。",
        universityTeacher:
          "認證電郵將會發送至以下的帳戶，請查閱電郵，以完成認證。",
      },
      eservicesUserName: "e-services 帳戶名稱",
      eservicesUserNameRetype: "再次輸入e-services 帳戶名稱",
      preServiceInstitution: "就讀的教育機構",
      teacherInstitution: {
        required: "請選擇教育機構",
        invalid: "無效的教育機構",
      },
      teacherEmail: {
        required: "請提供電郵地址",
        invalid: "無效的電郵地址",
        duplicated: "電郵地址已用於其他教城帳戶。請使用其他電郵地址再次登記。",
        improper: "您所輸入的電郵地址不正確 / 不適當。",
      },
      preServiceUserName: "學校帳戶名稱",
      preServiceUserNameRetype: "再次輸入學校帳戶名稱",
      preServiceEmailDomain: {
        required: "請提供學校電郵域名",
      },
      universityTeacherInstitution: "在職的教育機構",
      universityTeacherUserName: "學校帳戶名稱",
      universityTeacherUserNameRetype: "再次輸入學校帳戶名稱",
      universityTeacherEmailDomain: {
        required: "請提供學校電郵域名",
      },
      schoolInfoHeading: "任職學校（需經由學校管理員上載）",
      school: "學校",
      schoolName: "{name} （教城學校代號：{code}）",
      schoolEmail: "學校電郵",
      schoolEmailDomain: "學校電郵域名",
      schoolStaffInfo: {
        title: "查閱學校管理員資料",
        heading: "查閱學校管理員資料",
        schoolName: "學校名稱",
        staffName: "學校管理員姓名",
        staffContactCountryCode: "國家或地區（聯絡電話）",
        staffContactNumber: "聯絡電話",
        staffContactEmail: "聯絡電郵",
        closeWindow: "關閉",
        description: "如需更新學校電郵，請聯絡 貴校學校管理員：",
        invalid: "此功能只供校本老師使用，請更換帳戶再嘗試。",
      },
      teachingSubjectHeading: "主要任教科目/學習領域",
      subjectList: {
        invalid: "無效的資料格式",
      },
      teachingLevel: "任教程度",
      teachingLevels: {
        prePrimary: "學前",
        primary: "小學",
        secondary: "中學",
        tertiary: "大專",
        special: "特殊學校",
      },
      specialEduCurriculum: "請選擇特殊教育課程類別：（可選多項）",
      specialEduCurriculumList: {
        basic: "特殊教育（基礎教育課程）",
        senior: "特殊教育（高中教育課程）",
        basicId: "特殊教育（智障學生：基礎教育課程）",
        seniorId: "特殊教育（智障學生：高中課程）",
      },
      teachingSubject: "請選擇：",
      dutyHeading: "主要校內職務",
      dutyRemarkHeading: "其他職務",
      interestAreaHeading: "關注項目",
      interestAreaList: {
        invalid: "無效的資料格式",
      },
      dutyList: {
        invalid: "無效的資料格式",
      },
      dutyRemark: {
        required: "請提供其他校內職務",
        invalid: "無效的資料格式",
      },
      o365AccountHeading: "Microsoft Office 365 教育版帳戶",
      o365AccountDescription:
        "透過結合教城完備的教師會員系統及Microsoft Office 365 教育版 （Office 365 A1）帳戶的全面功能，免費支援教師輕易地展開遙距教學，以及與同儕互相交流，促進跨校合作，共建專業教育社群。",
      applyO365AccountInstruction:
        "想免費申請Microsoft Office 365 教育版帳戶? {action}",
      o365LoginName: "登入名稱",
      useO365Instruction: "請登入 Microsoft Office 365 {link} 享用服務",
      authType: {
        invalid: "無效的帳戶認證類別",
      },
      eservicesUserNameUnmatch:
        "您所輸入的@:profile.teacher.eservicesUserName不相符。請重新輸入。",
      preServiceUserNameUnmatch:
        "您所輸入的@:profile.teacher.preServiceUserName不相符。請重新輸入。",
      universityTeacherUserNameUnmatch:
        "您所輸入的@:profile.teacher.universityTeacherUserName不相符。請重新輸入。",
    },
    parent: {
      heading: "更新家長身分資料",
      interestAreaHeading: "主要關注項目",
    },
  },
  edbRegistration: {
    heading: "登記香港教育城（教城）會員帳戶",
    loginEmailUserName: "教育局電郵",
    reconfirmLoginEmailUserName: "確認教育局郵件",
    step1: "提供教育局的電郵地址",
    step2: "接收電子郵件通知",
    step3: "準備使用教城服務",
    description:
      "歡迎各位教育局同工登記成為香港教育城（教城）的會員！作為教育局的策略性伙伴，教城希望閣下能夠更了解和掌握我們為學界提供的一系列學與教資源及服務，藉此促進合作發展。為此，我們設立了一個簡單的帳戶啟動機制，讓閣下可以簡便地申請屬於你的教城會員帳戶。<br> <br> 閣下只須填寫你的教育局電郵地址，我們便會即時把你的會員帳號和啟動帳戶的連結電郵給你<font color='#FF0000'>*</font>。你的會員身分等同於校本教師帳戶，閣下可以使用這個帳戶，使用教城的校本服務。",
    reminder:
      "<small><font color='#FF0000'>*</font>如閣下的教育局電郵地址失效，相應的教城會員帳戶亦會自動停止服務。</small>",
    contact: "如有任何查詢，請電郵往 {supportEmail}。",
    supportEmailLink: "mailto: support@edcity.hk",
    supportEmail: "support@edcity.hk",
    registerButton: "登記教城帳戶",
    submitCreate: "提交登記",
    completed:
      "歡迎登記成為香港教育城（教城）會員。您的帳戶登入電郵是 {loginEmail} 。啟動帳戶電郵已發送至 {emailSentTo} 。",
    loginEmailUnaccepted: "此電郵不能作為登記用戶，請使用其他電郵登記。",
    loginEmailInUse: "電郵地址已用於其他教城帳戶。請使用其他電郵地址再次登記。",
    loginEmailPending: "此電郵地址已被登記，並正等待啟用。",
  },
  registration: {
    heading: "建立個人帳戶",
    accountAssociationDesc:
      "自動關聯至您的學生帳戶(登入名稱: {linkedLoginId} )",
    notAllowLinkUser: "抱歉。此連結無效。",
    loginEmail: "登入電郵",
    loginEmailHint: "以此電郵登入帳戶",
    surname: "姓氏",
    givenName: "名字",
    tos: "服務條款",
    acceptTos:
      "我已閱讀並同意香港教育城訂立的 {privacy}、 {copyright}、 {disclaimer}和 {tac}",
    privacyStatement: "私隱政策聲明",
    privateStatementUrl: "https://www.edcity.hk/home/zh-hant/dataprivacy",
    copyright: "版權及知識產權",
    copyrightUrl: "https://www.edcity.hk/notices/tc_chinese.php#s2",
    disclaimer: "免責聲明",
    disclaimerUrl: "https://www.edcity.hk/notices/tc_chinese.php#s3",
    tac: "服務條款",
    tacUrl: "https://www.edcity.hk/notices/tc_chinese.php#s4",
    submitCreate: "建立帳戶",
    completed:
      "歡迎登記成為教城會員。您的帳戶登入電郵是 {loginEmail} 。啟動帳戶電郵已發送至 {emailSentTo} 。請於 {validThru} 或之前啟動帳戶，否則須重新登記。",
    loginEmailUnaccepted: "此電郵不能作為登記用戶，請使用其他電郵登記。",
    loginEmailInUse: "電郵地址已用於其他教城帳戶。請使用其他電郵地址再次登記。",
    loginEmailPending: "此電郵地址已被登記，並正等待啟用。",
    alreadyVerifiedAsTeacher:
      "電郵地址已用於其他教城個人教師帳戶。請使用其他電郵地址再次登記。",
    surnameBadword: "切勿使用不雅用語，請輸入其他姓氏。",
    givenNameBadword: "切勿使用不雅用語，請輸入其他名字。",
    birth: "出生年份",
    gender: {
      label: "性别",
      female: "女",
      male: "男",
    },

    selfClaimRolesList: {
      heading: "您的身分:",
      label: "身分",
      TEACHER: "老師",
      STUDENT: "學生",
      PARENT: "家長",
    },
  },
  teacherAuthVerify: {
    heading: "教城教師帳戶驗證",
    success: "您已成功更改驗證教師帳戶。",
    fail: "錯誤！",
    required: "請提供驗證連結。",
    invalid: "這不是正確的確認電郵網址！",
    verified: "驗證連結已被使用。",
    expired: "這連結已超時失效。",
    teacherEmail: {
      duplicated: "電郵地址已用於其他教城帳戶。請使用其他電郵地址再次登記。",
    },
    user: {
      invalid: "帳戶無效。",
    },
  },
  loginEmailVerification: {
    heading: "確認電郵地址為登入帳號",
    success: "您已成功更改登入電郵至 {email}。",
    fail: "錯誤！",
    invalid: "這不是正確的電郵確認網址！",
    verified: "驗證連結已被使用。",
    expired: "這連結已超時失效。",
    duplicated: "此電郵地址已用於其他教城帳戶作登入電郵。",
  },
  contactEmailVerification: {
    heading: "確認更改聯絡電郵",
    success: "您已成功更改聯絡電郵至 {email}。",
    fail: "錯誤！",
    invalid: "這不是正確的電郵確認網址！",
    verified: "驗證連結已被使用。",
    expired: "這連結已超時失效。",
  },
  emailSubscriptionVerification: {
    heading: "確認更改訂閱",
    success: "您已成功更改訂閱至：",
    fail: "錯誤！",
    invalid: "這不是正確的電郵確認網址！",
    verified: "驗證連結已被使用。",
    expired: "這連結已超時失效。",
  },
  organizationAccountList: {
    itemsPerPage: {
      0: "每頁顯示",
      1: "行",
    },
    teacher_type: {
      PRE_SERVICE: "學生",
      UNIVERSITY_TEACHER: "教職員",
    },
    readOnly: "只讀模式",
    emailAddress: "電郵地址",
    chFullName: "中文姓名",
    enFullName: "英文姓名",
    remark: "備註",
    updatedAt: "修改時間",
    updatedBy: "修改者",
    actions: "動作",
    add: "新增",
    edit: "修改",
    save: "儲存",
    cancel: "取消",
    delete: "刪除",
    confirm: "您確定要刪除此記錄嗎？",
    search: "搜尋",
    group: "選擇群組：",
    itemsPerPageText: "每頁顯示：",
    pageText: "{0}-{1} 共 {2} 個紀錄",
    import: "匯入",
    editItem: {
      emailAddress: {
        label: "電郵地址",
        validation: {
          maxLength: "輸入長度超過限制",
          duplicated: "輸入電郵地址已重覆",
          improper: "輸入電郵地址格式不正確",
        },
      },
      chFullName: {
        label: "中文姓名",
        validation: {
          maxLength: "輸入長度超過限制",
        },
      },
      enFullName: {
        label: "英文姓名",
        validation: {
          maxLength: "輸入長度超過限制",
        },
      },
      remark: {
        label: "備註",
        validation: {
          maxLength: "輸入長度超過限制",
        },
      },
      updatedAt: {
        label: "修改時間",
      },
      updatedBy: {
        label: "修改者",
      },
    },
    importFile: {
      label: "請選擇 .xlsx 檔案",
      validation: {
        file: {
          required: "請提供匯入檔案",
          invalid: "匯入檔案格式不正確",
          exceedMax: "匯入檔案不可超過1,000條記錄",
        },
        emailAddress: {
          invalid: "匯入檔案中的電郵格式不正確",
          improper: "匯入檔案中的電郵不正確",
          duplicated: "匯入檔案中的電郵地址已重覆",
          exceedMax: "匯入檔案中的電郵地址輸入長度超過254字元限制",
        },
        chFullName: {
          invalid: "匯入檔案中的中文姓名不正確",
          exceedMax: "匯入檔案中的中文姓名輸入長度超過100字元限制",
        },
        enFullName: {
          invalid: "匯入檔案中的英文姓名不正確",
          exceedMax: "匯入檔案中的英文姓名輸入長度超過100字元限制",
        },
        remark: {
          invalid: "匯入檔案中的備註不正確",
          exceedMax: "匯入檔案中的備註輸入長度超過100字元限制",
        },
      },
      downloadTemplate: "下載「XLS/XLSX」 範本",
    },
    export: "匯出",
    emailAddressUnaccepted: "無效的電子地址。",
  },
  googleSSO: {
    fail: "錯誤！",
    close: "關閉",
    heading: "導出Google帳戶供香港教育城單一登入註冊",
    clientId: "用戶端 ID",
    domain: "網域",
    getUsers: "查詢使用者",
    exportToExcel: "下載至 Excel 檔案",
  },
  subscription: {
    label: {
      email: "電郵地址",
      confirmEmail: "再次輸入電郵地址",
    },
    button: {
      confirm: "確認訂閲",
      reset: "重設",
      close: "關閉",
      backToHome: "返回主頁",
    },
    validations: {
      emailIsEmpty: "請輸入電郵地址。",
      emailFormatWrong: "電郵地址格式不正確，請重新輸入。",
      serviceIsEmpty: "請選擇希望接收的電子報及活動資訊。",
      confirmEmailIsEmpty: "請輸入有效電郵地址格式。",
      confirmEmailIsNotSame: "您所輸入的電郵地址不一致，請重新輸入。",
    },
    text: {
      emailIntro: "輸入電郵地址收取資訊<span class='red--text'>*</span>",
      useDataHeading: "使用個人資料作直接促銷",
      emailConfirm: "我們收到訂閱後，會於當天發出確認電郵。",
      emailVerification: "驗證電子郵件已傳送至您的電子郵件地址。請點擊電子郵件中的連結確認您的訂閱。",
      useDataContent:
        "<p>教城擬使用閣下的個人資料（包括姓名、電話號碼及電郵地址）以通知閣下有關教城及其合辦機構及支持機構的教育最新動向、優惠、活動、服務及產品。此等直接促銷會根據教城的私隱政策嚴格執行。閣下亦可隨時選擇不再接收這些電郵。教城在未得到閣下的同意前，不會使用閣下的個人資料作上述用途。 </p><p>本人願意接收電子報及有關教城及其合辦機構及支持機構的教育最新動向、優惠、活動、服務及產品的資訊。</p>",
      successHeading: "多謝您訂閱教城資訊",
      successInfo: "您將接收以下的電子報及活動資訊：",
    },
  },
  region: {
    HONGKONG: "香港",
    MACAU: "澳門",
    CHINA: "中國",
    OTHER: "其他",
  },
  districtHK: {
    YUENLONG: "元朗",
    YAUTSIMMONG: "油尖旺",
    WONGTAISIN: "黃大仙",
    WANCHAI: "灣仔",
    TUENMUN: "屯門",
    TSUENWAN: "荃灣",
    TAIPO: "大埔",
    SOUTHERN: "南區",
    SHAMSHUIPO: "深水埗",
    SHATIN: "沙田",
    SAIKUNG: "西貢",
    NORTH: "北區",
    KWUNTONG: "觀塘",
    KWAITSING: "葵青",
    KOWLOONCITY: "九龍城",
    ISLANDS: "離島",
    EASTERN: "東區",
    CENTRALANDWESTERN: "中西區",
  },
};